/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { updateCenterGraph } from "./updateCenterGraph";
import {
	setCriticalJobsData,
	setCurrentPlanDates,
	setDataRightChart,
	setKPI
} from "../store/slice/roomSlices/homeSlice";
import homeFields from "../store/constants/homeFields";
import store from "../store/store";

export const updateHomeRoom = (path, data) => {
	const dispatch = store.dispatch;

	const keys = path.split("/:");
	const root = keys[0];
	const depth = keys.length - 1;
	const field = keys[depth];

	switch (root) {
		case homeFields.KPI:
			dispatch(setKPI({ field, data }))
			break;

		case homeFields.CURRENT_PLAN_DATES:
			updateCurrentPlanDates(dispatch, data)
			break;

		case homeFields.DATA_RIGHT_CHART:
			dispatch(setDataRightChart(data))
			break;

		case homeFields.CRITICAL_JOBS_DATA:
			dispatch(setCriticalJobsData({ field, data }))
			break;

		case homeFields.CENTER_GRAPH:
			updateCenterGraph(dispatch, data)
			break;

		default:
			console.log("case: ", root, "not yet implemented");
			break;
	}
};

const updateCurrentPlanDates = (dispatch, retriveredData) => {
	const state = store.getState()

	const selected = state.user.engines.selected
	const data = retriveredData.map((x, i) => ({ ...x, engine: selected[i] }))
	dispatch(setCurrentPlanDates(data))
}